import { SESSION_APPOINTMENT_TYPES } from '../hooks/api/config';

/** Normaliza un nombre de servicio a solo letras minúsculas (sin tildes ni signos) para comparación fuzzy */
const normalizeForMatch = (s: string) =>
  s
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '') // quitar tildes
    .replace(/[^a-z]/g, ''); // solo letras

/**
 * Dado el nombre de servicio UI (ej. "Familia", "Pareja"), devuelve el `clinical_service` UUID
 * usando la tabla SESSION_APPOINTMENT_TYPES definida en config.ts.
 */
export function getClinicalServiceId(serviceName: string): string | null {
  const norm = normalizeForMatch(serviceName);
  const match = SESSION_APPOINTMENT_TYPES.find((t) => normalizeForMatch(t.name) === norm);
  return match?.clinical_service ?? null;
}
